<mat-card [@fadeInOut]>
    <mat-card-content class="padding" style="max-height: 100% !important;">
        <div class="margin">
            <div fxLayout="row wrap" fxLayoutAlign="space-between center">
                <div fxFlex="50" fxFlex.sm="100" fxFlex.xs="100">
                    <div fxFlex="70"
                        fxFlex.gt-md="70"
                        class="p-l-10">
                        <mat-form-field [@slideInOut]="(isDesktop ? search : true)"
                            style="position: relative;">
                            <mat-label>Buscar en tabla</mat-label>
                            <input matInput (keyup)="applyFilter($event)" placeholder="Usuarios"
                                #input>
                        </mat-form-field>
                    </div>
                    <div
                        class="p-l-10"
                    >
                        <mat-form-field appearance="outline">
                        <mat-label>Estatus</mat-label>
                        <mat-select [formControl]="formFilter.controls.Estado">
                            <mat-option value="">Todos</mat-option>
                            <mat-option *ngFor="let rol of uniqueRoles" [value]="rol">
                                {{ rol }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                  </div>
                </div>
                <div fxFlex="30" fxFlex.sm="100" fxFlex.xs="100" style="text-align: end;">
                    <button mat-stroked-button color="primary" (click)="createDialog()">Nuevo usuario</button>
                </div>
            </div>
        </div>
    </mat-card-content>
</mat-card>

<mat-card [@fadeInOut]>
    <mat-card-content class="padding" style="max-height: 100% !important;">

        <div style="text-align: center;" [hidden]="!dataLoaded">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            cargando...
        </div>

        <div class="mat-elevation-z8 table-responsive" style="margin-bottom: 10px;" [hidden]="dataLoaded">
            <table mat-table [dataSource]="dataSource" class="table employee-list no-wrap" matSort>

                <!-- ID Column -->
                <ng-container matColumnDef="number">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
                    <td mat-cell *matCellDef="let row; index as i"> {{i + 1 }} </td>
                </ng-container>

                <!-- Rol Column -->
                <ng-container matColumnDef="Rol">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Rol </th>
                    <td mat-cell *matCellDef="let row"> {{row.NombreRol}} </td>
                </ng-container>

                <!-- Nombre Column -->
                <ng-container matColumnDef="Nombre">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
                    <td mat-cell *matCellDef="let row"> {{row.Nombre}} </td>
                </ng-container>

                <!-- Nickname Column -->
                <ng-container matColumnDef="Nickname">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Nickname </th>
                    <td mat-cell *matCellDef="let row"> {{row.Nickname}} </td>
                </ng-container>

                <!-- Imagen Column -->
                <!-- <ng-container matColumnDef="RutaImagen">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Imagen </th>
                    <td mat-cell *matCellDef="let row">
                        <img src="{{row.RutaImagen}}" alt="" class="img-user">
                    </td>
                </ng-container> -->

                <!-- Email Column -->
                <ng-container matColumnDef="Email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Email </th>
                    <td mat-cell *matCellDef="let row"> {{row.Email}} </td>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="options">
                    <th mat-header-cell *matHeaderCellDef> Opciones </th>
                    <td mat-cell *matCellDef="let row">
                        <div fxLayout="row">
                            <button mat-menu-item color="primary" (click)="createDialog(row)">
                                <mat-icon class="edit">edit</mat-icon>
                            </button>
                            <button mat-menu-item color="warning" (click)="confirmDeleteUser(row)">
                                <mat-icon class="trash">delete_outline</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">No hay información "{{input.value}}"</td>
                </tr>
            </table>

            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="10"
                aria-label="Usuarios por página"></mat-paginator>
        </div>
        <!-- </div> -->
    </mat-card-content>
</mat-card>